import { render, staticRenderFns } from "./editService.vue?vue&type=template&id=52554905"
import script from "./editService.vue?vue&type=script&lang=js"
export * from "./editService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports